module.exports = __webpack_public_path__ + "static/media/enterprise.4703b5d2.svg";